const PENDING_ALERT_INTENT_KEY = 'jc-pending-alert-intent';

export interface PendingAlertIntent {
  /** The saved-search URL the user wanted alerts for, captured before the Auth0 redirect. */
  url: string;
  /** Whether the user also ticked the marketing-consent checkbox before signing in. */
  wantsMarketing: boolean;
}

/** Call right before redirecting to Auth0 so the intent survives the round trip. */
export function setPendingAlertIntent(intent: PendingAlertIntent): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(PENDING_ALERT_INTENT_KEY, JSON.stringify(intent));
  } catch {
    // sessionStorage unavailable (e.g. private mode quota) — the CTA simply won't auto-resolve.
  }
}

/** Reads and clears the pending intent, if any. Returns null if none was set. */
export function consumePendingAlertIntent(): PendingAlertIntent | null {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  const raw = sessionStorage.getItem(PENDING_ALERT_INTENT_KEY);
  if (!raw) {
    return null;
  }
  sessionStorage.removeItem(PENDING_ALERT_INTENT_KEY);
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed?.url === 'string' && parsed.url.length > 0) {
      return { url: parsed.url, wantsMarketing: parsed.wantsMarketing === true };
    }
    return null;
  } catch {
    return null;
  }
}
